module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: [_vm.size === 'large' ? 'nav-md' : 'nav-sm']
  }, [_c('div', {
    staticClass: "container body"
  }, [_c('div', {
    staticClass: "main_container"
  }, [_c('sidebar', {
    attrs: {
      "title": "Edexis",
      "menuItems": _vm.menuItems,
      "logout": _vm.logout.bind(this)
    }
  }), _vm._v(" "), _c('topmenu', {
    on: {
      "toggleSidebar": function($event) {
        return _vm.toggleSidebar()
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "right_col",
    staticStyle: {
      "min-height": "1080px"
    },
    attrs: {
      "role": "main"
    }
  }, [_c('router-view')], 1), _vm._v(" "), _vm._m(0)], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', [_c('div', {
    staticClass: "clearfix"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9853d128","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Layout/Console.vue
// module id = 345
// module chunks = 1